import * as React from "react";
import type { SVGProps } from "react";
const SvgStopwatch04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m9.6 9.687 2.583 3.617H16.2M9.4 1.287h5.287m5.009 2.226L22.2 6.017m-20.4.174 2.504-2.504m17.061 9.843A9.183 9.183 0 1 1 3 13.53a9.183 9.183 0 0 1 18.365 0"
    />
  </svg>
);
export default SvgStopwatch04;
